// extracted by mini-css-extract-plugin
export default {"collabTypeBadge":"CollabTypeBadge_collabTypeBadge__7Rc1g"};